<template>
  <div
    id="activity-navbar-wrapper-v2"
    class="activity-v2-navbar position-fixed ff-primary"
  >
    <nav id="activity-navbar-v2" class="navbar navbar-expand-lg activity-v2-navbar-inner">
      <router-link
        id="navbar-back"
        :to="backProgrammuLink"
        class="navbar-brand back-btn"
        @click="logEventAnalytic('HALAMAN_BELAJAR_BACK_BUTTON_CLICK')"
      >
        <img src="https://cdn.karier.mu/assets/icon-mini/halaman-belajar/icon-back-kelasku.svg" alt="Navbar Back Btn"/>
      </router-link>
      <div class="nav-mobile d-lg-none">
        <div class="left-nav-mobile">
          <a
            class="logo-mobile"
            id="logo-mobile"
            :href="logoUrl"
            @click="logEventAnalytic('HALAMAN_BELAJAR_LOGO_CLICK')"
          >
            <img
              alt="Karier.mu"
              class="kariermu-logo"
              :src="logoSrcUrl"
            />
          </a>
          <div class="line-separator"></div>
          <router-link
            id="activity-name-mobile"
            :to="`/program/${activityDashboard.slug}`"
            class="activity-name text-decoration-none one-line-ellipsis"
            @click="logEventAnalytic('HALAMAN_BELAJAR_JUDUL_PROGRAM_CLICK')"
          >
            {{ activityDashboard.name }}
          </router-link>
        </div>
        <div class="menu-mobile d-flex">
          <div id="mobile-current-progress" class="d-flex align-items-center">
            <div id="toggle-show-progress" role="button" @click="toggleShowProgressDetailBottomSheet">
              <progress-circle
                ref="progressCircleMobile"
                :activity-percentage="activityDashboard.percentage_progress"
                :presence-percentage="activityDashboard.percentage_presence_participation"
                :is-show-presence-participation="isShowPresenceParticipation"
              ></progress-circle>
            </div>
          </div>
          <s-bottom-sheet
            id="navbar-progress-detail-bottom-sheet"
            :value="isShowProgressDetailBottomSheet"
            @input="$emit('update:isShowProgressDetailBottomSheet', $event)"
            show-toggler
            click-to-close
            cluster="k"
            max-height="fit-content"
          >
            <progress-detail
              :activity-progress-data="activityProgressData"
              :presence-progress-data="presenceProgressData"
            />
          </s-bottom-sheet>
          <others-bottom-sheet-menu
            is-mobile
            :facil-room-id="facilRoomId"
            :is-tanyamu-closed="isTanyamuClosed"
            :is-tanyamu="isShowTanyamu"
            @showShareModal="toggleShareModal"
            @toggleChatBox="toggleChatBox"
            @logEventAnalytic="logEventAnalytic"
          />
        </div>
      </div>
      <div
        class="collapse navbar-collapse"
        id="navbarContent"
      >
        <ul class="navbar-nav left-nav">
          <li class="nav-item">
            <a
              id="back-to-home"
              :href="logoUrl"
              class="nav-link"
              data-title="Kembali ke Halaman Utama"
              @click="logEventAnalytic('HALAMAN_BELAJAR_LOGO_CLICK')"
            >
              <img
                alt="Karier.mu"
                class="kariermu-logo"
                :src="logoSrcUrl"
              />
            </a>
          </li>
          <li class="line-separator-item">
            <span class="line-separator"></span>
          </li>
          <li class="nav-item">
            <router-link
              id="activity-name-desktop"
              :to="`/program/${activityDashboard.slug}`"
              @click="logEventAnalytic('HALAMAN_BELAJAR_JUDUL_PROGRAM_CLICK')"
              class="nav-link inter-medium-bold activity-name"
              :class="{
                'activity-name-width': !isSidebarVisible,
                'activity-name-width-sidebar': isSidebarVisible
              }"
              :data-title="activityDashboard.name"
            >
              {{ activityDashboard.name }}
            </router-link>
          </li>
        </ul>
        <!-- Right nav items -->
        <ul class="navbar-nav right-nav ml-auto right-items">
          <!-- Progress Circle with Custom Tooltip -->
          <li
            id="current-progress"
            class="nav-item d-flex align-items-center s-mr-3"
          >
            <div
              class="progress-circle-container"
              @mouseenter="showProgressDetailTooltip = true"
              @mouseleave="handleMouseLeaveProgressCircle"
            >
              <progress-circle
                ref="progressCircle"
                :activity-percentage="activityDashboard.percentage_progress"
                :presence-percentage="activityDashboard.percentage_presence_participation"
                :is-show-presence-participation="isShowPresenceParticipation"
              />
              <div
                v-show="showProgressDetailTooltip"
                class="tooltip-wrapper"
              >
                <!-- Invisible connector -->
                <div class="tooltip-connector"></div>
                <!-- Actual tooltip content -->
                <div
                  class="custom-tooltip"
                  @mouseenter="handleTooltipProgressDetailEnter"
                  @mouseleave="handleTooltipProgressDetailLeave"
                >
                  <div class="navbar-progress-detail-wrapper">
                    <progress-detail
                      :activity-progress-data="activityProgressData"
                      :presence-progress-data="presenceProgressData"
                    />
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- Tanyamu/Share Button -->
          <li class="nav-item d-flex justify-content-center align-items-center">
            <a
              v-if="isShowTanyamu"
              id="tanyamu-button"
              href="#"
              class="nav-link p-0"
              data-title="Tanyamu"
              @click.prevent="toggleChatBox"
            >
              <img
                class="activity-icon"
                src="https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-tanyamu-kariermu.svg"
                alt="Tanyamu"
              />
            </a>
            <a
              v-else
              id="share-button"
              href="#"
              class="nav-link p-0"
              data-title="Bagikan"
              @click.stop.prevent="toggleShareModal"
            >
              <img
                class="activity-icon"
                src="https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-bagikan-kariermu.svg"
                alt="Share"
              />
            </a>
          </li>
          <others-dropdown-menu
            :facil-room-id="facilRoomId"
            :is-tanyamu="isShowTanyamu"
            @showShareModal="toggleShareModal"
            @logEventAnalytic="logEventAnalytic"
          />
          <s-button
            v-show="!isSidebarVisible"
            id="activity-navbar-list-activity"
            cluster="k"
            variant="ghost"
            :class="btnToggleSidebarClass"
            @click="toggleSidebar('daftar_aktivitas_click')"
          >
            <font-awesome-icon class="s-mr-1" icon="chevron-left" />&nbsp;
            Daftar aktivitas
          </s-button>
        </ul>
      </div>
    </nav>
    <share-modal :is-shown="isShownShareModal" @close="closeShareModal" />
    <rating-modal
      v-if="activityDashboard && activityValidate.creator"
      v-model="isShowRatingModal"
      :creator="activityValidate.creator"
      @posted="getActivityDashboard"
    />
    <b-modal-kariermu
      centered
      hide-footer
      hide-header
      id="new-password-modal"
      :is-shown="modalNewPassword"
      size="new-password"
      @close="modalNewPassword = false"
    >
      <template #content>
        <modal-new-password
          @toggleNewPassword="toggleNewPassword"
          @toggleDaftar="toggleDaftar"
          @toggleMasuk="toggleMasuk"
          @toggleConfirmationPassword="toggleConfirmationPassword"
          class="open-sans open-sans-v2"
        />
      </template>
    </b-modal-kariermu>
    <b-modal-kariermu
      centered
      hide-footer
      hide-header
      id="confirmation-password-modal"
      :is-shown="modalConfirmationPassword"
      size="new-password"
      @close="modalConfirmationPassword = false"
    >
      <template #content>
        <modal-confirmation-password
          @toggleNewPassword="toggleNewPassword"
          @toggleDaftar="toggleDaftar"
          @toggleMasuk="toggleMasuk"
          @toggleConfirmationPassword="toggleConfirmationPassword"
          class="open-sans open-sans-v2"
        />
      </template>
    </b-modal-kariermu>
    <b-modal-kariermu
      centered
      hide-footer
      hide-header
      id="confirmation-register-modal"
      :is-shown="modalConfirmationRegister"
      size="new-password"
      @close="modalConfirmationRegister = false"
    >
      <template #content>
        <modal-confirmation-register
          @toggleNewPassword="toggleNewPassword"
          @toggleDaftar="toggleDaftar"
          @toggleMasuk="toggleMasuk"
          @toggleConfirmationPassword="toggleConfirmationPassword"
          @toggleConfirmationRegister="toggleConfirmationRegister"
          class="open-sans open-sans-v2"
        />
      </template>
    </b-modal-kariermu>
    <b-modal-kariermu
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-footer
      hide-header
      id="limited-program-access-modal"
      :is-shown="hasLimitedProgramAccess"
      size="sm"
      @close="hasLimitedProgramAccess = false"
    >
      <template #content>
        <modal-blocker-program-terbatas-warning-only />
      </template>
    </b-modal-kariermu>
    <otp-verification key="otp-verification" />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import deviceDetector from 'mobile-device-detect'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapState } from 'vuex'
import chat from '@/api/chat'
import { sendNetcore } from '@/functions/tracker/netcore'
import ProgressDetail from '@/components/activityV2/ActivityHeader/ProgressDetail.vue'
import ProgressCircle from '@/components/activityV2/ActivityHeader/ProgressCircle.vue'
import OthersDropdownMenu from '@/components/activityV2/ActivityHeader/OthersDropdownMenu.vue'
import OthersBottomSheetMenu from '@/components/activityV2/ActivityHeader/OthersBottomSheetMenu.vue'
import ShareModal from '@/components/activityV2/ActivityHeader/ShareModal.vue'
import activityV2SidebarMixin from '@/mixins/activityV2SidebarMixin'
import activityV2GeneralMixin from '@/mixins/activityV2/general'
import platinumMixin from '@/mixins/platinumMixin'
import ProgramActivityAPI from '@/api/program-activity'
import ModalNewPassword from '@/components/navbar/ModalNewPassword'
import ModalConfirmationPassword from '@/components/navbar/ModalConfirmationPassword'
import ModalConfirmationRegister from '@/components/navbar/ModalConfirmationRegister'
import ModalBlockerProgramTerbatasWarningOnly from '@/components/validator/ModalBlockerProgramTerbatasWarningOnly'
import OtpVerification from '@/components/otpUserVerification/OtpVerification'

export default {
  name: 'ActivityHeader',
  components: {
    RatingModal: defineAsyncComponent(() => import('@/components/activityV2/Modal/RatingModalV2.vue')),
    FontAwesomeIcon,
    ProgressDetail,
    ProgressCircle,
    OthersDropdownMenu,
    OthersBottomSheetMenu,
    ShareModal,
    ModalNewPassword,
    ModalConfirmationPassword,
    ModalConfirmationRegister,
    ModalBlockerProgramTerbatasWarningOnly,
    OtpVerification
  },
  mixins: [activityV2SidebarMixin, activityV2GeneralMixin, platinumMixin],
  data () {
    return {
      isShowRatingModal: false,
      ratingModalProps: {},
      isMobile: deviceDetector.isMobile,
      modalNewPassword: false,
      modalConfirmationPassword: false,
      modalConfirmationRegister: false,
      isFromProgramDetail: false,
      isShowProgressDetailBottomSheet: false,
      isShownShareModal: false,
      showProgressDetailTooltip: false,
      isHoveringProgressDetailTooltip: false
    }
  },
  computed: {
    ...mapState('activityV2', ['activityDashboard', 'isChatBoxOpen', 'facilRoomId', 'report']),
    ...mapState('program', ['isOpenChildProgram']),
    isShowTanyamu () {
      const roomId = this.program.room_id > 0
      const checkRoomType = this.program.type_room === 'group' || this.program.type_room === 'channel'

      return roomId && checkRoomType && !this.isTanyamuClosed
    },
    backProgrammuLink () {
      let link = `/programmu${this.queryParam}`
      const folderId = this.activityDashboard.folder_id
      if (folderId) {
        link = `/programmu?folder=${folderId}&subdomain_slug=${this.platinumSlug}`
      }
      return link
    },
    storage () {
      return this.$store.state.storage
    },
    dataProgramDescription: {
      get () {
        return this.$store.state.activity.dataProgramDescription
      },
      set (value) {
        this.$store.commit('activity/CHANGE_DATA_PROGRAM_DESCRIPTION', value)
      }
    },
    isTanyamuClosed () {
      return !!this.dataProgramDescription.is_tanyamu_closed
    },
    userInfo () {
      return this.$store.state.user.userInfo
    },
    isQisqusDataAvailable () {
      return this.$store.state.tanyamu.qiscus
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    hasLimitedProgramAccess () {
      return !this.activityValidate.is_joined && this.activityValidate.has_user_group
    },
    isShowPresenceParticipation () {
      const {
        using_presence_participation,
        category_name
      } = this.activityDashboard
      return ['KARIERMU', 'PRAKERJA', 'KAMPUS_MERDEKA'].includes(category_name) && !!using_presence_participation
    },
    isActivityLinier () {
      return this.activityValidate.linier
    },
    isPrakerjaRatingRule () {
      const {
        total_presence_participation_resource
      } = this.activityDashboard
      return this.isPrakerjaCategory && this.isActivityLinier && total_presence_participation_resource >= 1
    },
    activityProgressData () {
      return {
        current: this.activityDashboard.completed_resources,
        total: this.activityDashboard.total_resources,
        percentage: this.activityDashboard.percentage_progress
      }
    },
    presenceProgressData () {
      if (this.isShowPresenceParticipation) {
        return {
          current: this.activityDashboard.completed_presence_resource,
          total: this.activityDashboard.total_presence_participation_resource,
          percentage: this.activityDashboard.percentage_presence_participation
        }
      }
    },
    dataProgramActivity () {
      return this.$store.state.activity.dataProgramActivity
    },
    btnToggleSidebarClass () {
      return ['btn-toggle-activity-v2-sidebar position-relative', this.isAccessedFromKariermuB2bApp ? 'd-none' : '']
    }
  },
  methods: {
    showRatingModalIfEligible () {
      const today = new Date()
      const scoringDate = new Date(this.report.scoring_date)
      const { percentage_progress, is_rated, is_available_to_rate, pmo_id } = this.activityDashboard
      switch (true) {
        case today > scoringDate && is_rated === 0 && percentage_progress > 49 && !this.isPrakerjaRatingRule:
        case is_available_to_rate && scoringDate && is_rated === 0 && percentage_progress > 49 && !pmo_id && !this.isPrakerjaRatingRule:
        case this.isPrakerjaRatingRule && percentage_progress >= 100 && is_rated === 0:
        case !this.isOpenChildProgram && percentage_progress >= 100 && is_rated === 0:
          this.$store.commit('activityV2/TOGGLE_SIDEBAR', false)
          this.isShowRatingModal = true
          this.logEvent()
          break

        default:
          // not eligible to show rating modal
          this.isShowRatingModal = false
          break
      }
    },
    toggleShareModal () {
      this.isShownShareModal = !this.isShownShareModal
      this.logEventAnalytic('halaman_belajar_share_click')
    },
    closeShareModal () {
      this.isShownShareModal = false
    },
    toggleShowProgressDetailBottomSheet () {
      this.isShowProgressDetailBottomSheet = !this.isShowProgressDetailBottomSheet
    },
    handleTooltipProgressDetailEnter () {
      this.isHoveringProgressDetailTooltip = true
      this.showProgressDetailTooltip = true
    },

    handleTooltipProgressDetailLeave () {
      this.isHoveringProgressDetailTooltip = false
      this.showProgressDetailTooltip = false
    },

    handleMouseLeaveProgressCircle (event) {
      // Check if mouse is entering the tooltip or connector
      const tooltipWrapper = event.currentTarget.querySelector('.tooltip-wrapper')
      if (tooltipWrapper && tooltipWrapper.contains(event.relatedTarget)) {
        return
      }
      this.showProgressDetailTooltip = false
    },
    async getActivityDashboard () {
      const activityDashboard = await ProgramActivityAPI.getActivityDashboard({
        data: {
          user_id: this.storage.userId,
          program_user_id: this.activityValidate.program_user_id,
          id: this.activityValidate.program_id
        },
        Authorization: this.storage.accessToken
      })
      if (activityDashboard.data.status === 200) {
        this.$store.commit(
          'activityV2/SET_ACTIVITY_DASHBOARD',
          activityDashboard.data.data
        )
      }
    },
    async initProgramFacils () {
      try {
        const token = this.$store.state.storage.accessToken
        const url = `/program_activity/v2/product_by_activity/${this.$route.params.id}/description`

        const data = await chat.initProgramFacils(url, token)

        if (data.status === 200) {
          this.$store.commit('activityV2/SET_FACIL_ROOM_ID', parseInt(data.data.room_id))
          this.dataProgramDescription = data.data
        }
      } catch (err) {
        console.error(err)
      }
    },
    async toggleChatBox () {
      await this.initProgramFacils()

      if (!this.isQisqusDataAvailable) {
        const dataLogin = await this.$store.dispatch('user/fetchUserData')

        if (dataLogin.status === 200) {
          await this.$store.dispatch('tanyamu/loginQiscus')
        }
      }
      // this.switchToTab('activity')
      this.$store.commit('activityV2/SET_CHAT_BOX', !this.isChatBoxOpen)
      this.logEventAnalytic('halaman_belajar_tanyamu_click')
    },
    toggleMasuk (isClicked) {
      this.modalRegister = false
      this.modalNewPassword = false
      this.modalConfirmationPassword = false
      this.modalConfirmationRegister = false
      this.modalOtp = false
      this.isClicked = !!isClicked
    },
    toggleNewPassword () {
      this.modalRegister = false
      this.modalConfirmationPassword = false
      this.modalConfirmationRegister = false
      this.modalOtp = false

      this.modalNewPassword = !this.modalNewPassword
    },
    toggleDaftar (payload) {
      this.isSend = false
      this.modalNewPassword = false
      this.modalConfirmationPassword = false
      this.modalConfirmationRegister = false
      this.modalOtp = false

      this.modalRegister = !this.modalRegister

      if (payload?.origin === 'program_detail') {
        this.isFromProgramDetail = true
      }
    },
    toggleConfirmationPassword () {
      this.modalRegister = false
      this.modalNewPassword = false
      this.modalConfirmationRegister = false
      this.modalOtp = false

      this.modalConfirmationPassword = !this.modalConfirmationPassword
    },
    toggleConfirmationRegister () {
      this.modalRegister = false
      this.modalNewPassword = false
      this.modalConfirmationPassword = false
      this.modalOtp = false

      this.modalConfirmationRegister = !this.modalConfirmationRegister
    },
    logEvent () {
      const eventParams = {
        program_progress: parseFloat(this.activityDashboard?.percentage_progress ?? 0).toFixed(2),
        program_id: this.activityDashboard?.id ?? 'NA',
        program_name: this.activityDashboard?.name ?? 'NA',
        program_slug: this.activityDashboard?.slug ?? 'NA',
        program_type: this.activityDashboard?.pmo_id ? 'prakerja' : 'nonprakerja',
        program_url: `https://${window.location.hostname}/program/${this.activityDashboard?.slug}`,
        total_activity: this.activityDashboard.total_presence_participation_resource && parseInt(this.activityDashboard.total_presence_participation_resource) > 0 ? parseInt(this.activityDashboard?.total_presence_participation_resource) : 'NA',
        total_minute: parseInt(this.activityDashboard?.duration_completed_program) === 0 ? 'NA' : parseInt(this.activityDashboard?.duration_completed_program),
        institution_id: this.activityValidate.creator_id || 'NA',
        institution_name: this.activityValidate.creator || 'NA',
        is_on_external_lms: String(this.activityValidate.is_external)
      }
      sendNetcore('program_completed', this.userInfo, eventParams)
      window.firebaseAnalytics.logEvent('program_completed', eventParams)
    }
  },
  watch: {
    report (newValue) {
      if ('scoring_date' in newValue && newValue.scoring_date) {
        this.showRatingModalIfEligible()
      }
    },
    'activityResourceDetail.is_complete' (newValue, oldValue) {
      // * specifically oldValue === false ( not null or undefined ) to prevent calling getActivityDashboard multiple times
      (!!newValue && oldValue === false) && this.getActivityDashboard()
    },
    'activityDashboard.percentage_progress' (value, old) {
      if (value !== old) {
        this.$refs.progressCircle.updateActivityProgress(value)
        this.$refs.progressCircleMobile.updateActivityProgress(value)
        this.showRatingModalIfEligible()
      }
    },
    'activityDashboard.percentage_presence_participation' (value, old) {
      if (value !== old) {
        this.$refs.progressCircle.updatePresenceProgress(value)
        this.$refs.progressCircleMobile.updatePresenceProgress(value)
      }
    }
  },
  created () {
    this.getActivityDashboard()
  },
  mounted () {
    this.$nextTick(() => {
      this.showRatingModalIfEligible()
    })
  },
  beforeUnmount () {
    this.$store.commit('activityV2/SET_ACTIVITY_DASHBOARD', {})
  }
}
</script>
<style lang="scss" scoped>
.activity-v2-navbar {
  box-shadow: 0 2px 8px var(--color-medium-shadow);
  -webkit-transition: width 0.3s ease-in-out;
  -o-transition: width 0.3s ease-in-out;
  transition: width 0.3s ease-in-out;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 12;
}
.activity-v2-navbar-inner {
  background: var(--color-neutral-100);
  padding: 4px 16px;
  height: 48px;
}
.activity-name {
  /* Not using pre-defined variable/class for multiple breakpoints media query purposes */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
}
.activity-name ::v-deep a {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.activity-name-width ::v-deep a {
  max-width: calc(100vw - 650px);
}
.activity-name-width-sidebar ::v-deep a {
  max-width: calc(100vw - 880px);
}
.activity-name .nav-link,
.nav-mobile .activity-name, a {
  color: var(--color-ui-element-black);
}
.back-btn {
  box-shadow: 0 7px 10px var(--color-medium-shadow);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 24px;
  height: 24px;
}
.back-btn > img {
  width: 80%;
}
.activity-icon {
  width: 24px;
  height: 24px;
  margin: 0 8px;
}
.others-dropdown-menu .btn-group > .btn:focus {
  box-shadow: none;
}
.activity-v2-navbar .navbar {
  justify-content: flex-start;
}
.nav-mobile {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
}
.progress-wrapper {
  padding-right: 40px;
}
.progress-text {
  position: absolute;
  left: 45px;
}
.activity-v2-navbar ::v-deep .dropdown-item {
  padding: 0 30px 0 10px;
  color: var(--color-royal-navy-500);
}
.activity-v2-navbar ::v-deep .dropdown-item .activity-icon {
  margin-right: 8px;
}
.activity-v2-navbar ::v-deep .others-dropdown-menu .dropdown-menu {
  margin-top: 20px;
  border: transparent;
  box-shadow: 0 16px 20px 1px rgb(51 51 51 / 10%);
  border-radius: 10px;
  padding: 20px 10px;
}
.kariermu-logo {
  width: auto;
  max-height: 30px;
}
.open-sans-v2 {
  margin: 13px 0
}
.left-nav-mobile {
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
  gap: 4px;
}
.line-separator {
  border-left: solid 1.5px var(--color-ui-element-grey-5);
  margin: 0 10px;
  height: 36px;
}
.kariermu-logo,
.line-separator {
  display: none;
}
.menu-mobile {
  gap: 4px;
}
:deep(.bottom-sheet__card) {
  height: fit-content !important;
}
:deep(.s-bottom-sheet-container) {
  max-width: unset !important;
}
:deep(.s-bottom-sheet-content) {
  padding: 0 16px 16px;
}
.progress-circle-container {
  position: relative;
}
.tooltip-wrapper {
  position: absolute;
  top: 100%;
  right: 0;
  transform: translateX(4%);
}
.tooltip-connector {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 12px;
  background: transparent;
}
.custom-tooltip {
  position: relative;
  top: 6px;
  right: 12px;
  background-color: var(--color-neutral-100);
  border-radius: 10px;
  box-shadow: 0 2px 8px var(--color-medium-shadow);
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
  z-index: 3;
}
.navbar-progress-detail-wrapper {
  color: var(--color-text-primary);
  width: 300px;
  padding: 16px 15px;
}

.right-nav .nav-item {
  width: 40px;
  height: 40px;
}

@media (min-width: 453px) {
  .back-btn {
    width: 36px;
    height: 36px;
  }
  .activity-v2-navbar-inner {
    padding: 8px 16px;
    height: 72px;
  }
  .activity-name {
    font-size: 18px;
  }
}
@media (min-width: 767px) {
  .kariermu-logo,
  .line-separator {
    display: flex;
  }
}
@media (min-width: 992px) {
  .nav-mobile {
    display: none;
  }
  .activity-name:hover a .nav-link {
    color: var(--color-ui-text-secondary);
  }
  [data-title]:hover::before {
    content: attr(data-title);
    position: absolute;
    box-shadow: 0 2px 8px rgba(51, 51, 51, 0.1);
    border-radius: 10px;
    padding: 4px;
    top: 60px;
    background: var(--color-ui-element-white-3);
    color: var(--color-ui-text-secondary-2);
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;
  }
  .others-dropdown-menu[data-title]:hover::before {
    top: 40px;
    right: 0;
  }
  .activity-navbar-wrapper ::v-deep .navbar-expand-lg .left-nav {
    flex: 1;
    min-width: 0;
  }
  .activity-navbar-wrapper ::v-deep .navbar-expand-lg .navbar-collapse {
    min-width: 0;
  }
  .activity-v2-navbar-inner .btn-toggle-activity-v2-sidebar {
    right: -13px;
  }
  .activity-v2-navbar-inner .btn-toggle-activity-v2-sidebar > :deep(.flex) {
    align-items: center;
  }
  .custom-tooltip {
    max-width: 300px;
    margin: 12px;
  }
}
</style>
